<div class="modal-content sq-preview-popup">
    <sq-modal 
        [title]="recordTitle"
        [showFooter]="false">
        <div header *ngIf="showPreviousNext" class="previousNextDocumentButtons">
            <button class="btn btn btn-outline-primary {{!previousEnabled ? 'disabled' : ''}}" (click)="previous()">
                <span class="fas fa-arrow-left" aria-hidden="true"></span><span *ngIf="showPreviousNextText"> {{'msg#preview.previousDocument' | sqMessage}}</span>
            </button>
            <button class="btn btn btn-outline-primary {{!nextEnabled ? 'disabled' : ''}}" (click)="next()">
                <span class="fas fa-arrow-right" aria-hidden="true"></span><span *ngIf="showPreviousNextText"> {{'msg#preview.nextDocument' | sqMessage}}</span>
            </button>
        </div>
        <sq-preview-panel [leftPaneAdditionalClasses]="'d-none d-lg-block'" [query]="model.query" [previewData]="previewData" [displaySimilarDocuments]="model.displaySimilarDocuments" [metadata]="model.metadata">
        </sq-preview-panel>
    </sq-modal>
</div>